import axios from 'axios'
import {
  getQueryString,
  getToken,
  getPersonalToken,
  getCookieItem,
  formatSearch,
  queryParams,
  bMobile,
  isPersonal,
  getUrlParams
} from '@/utils'
import { message } from 'antd'
import { Toast } from 'antd-mobile'
import i18n from 'i18next'

const isDev = /^(dev|local)/.test(process.env.REACT_APP_KZ_ENV)
const instance = axios.create({
  timeout: 60 * 60 * 1000,
  withCredentials: false
})

export const showToast = (str, opt = {}) => {
  if (bMobile) {
    Toast.show({
      icon: 'fail', // 'success' | 'fail' | 'loading' | React.ReactNode
      content: str,
      // position: 'bottom', // 'top' | 'bottom' | 'center'
      // duration: 0,
      maskStyle: {
        '--z-index': 99999
      },
      ...opt
    })
  } else {
    message.error(str)
  }
}

const goLoginForAiHelper = () => {
  // 小程序 跳转到授权页
  const redirectTo = window?.wx?.miniProgram?.redirectTo
  const wxapp = !!getQueryString('wxapp')
  if (redirectTo && wxapp) {
    setTimeout(() => {
      redirectTo({
        url: '/pages/authorize/authorize'
      })
    }, 2000)
    return
  }
  // 移动端 跳转到 SaaS移动端 登录页
  const search = formatSearch(window.location.search)
  delete search.token
  delete search.personalToken
  setTimeout(() => {
    window.location.href = `${
      process.env.REACT_APP_USER_URL
    }/saasMobile/login?redirectUrl=${encodeURIComponent(
      `${process.env.REACT_APP_USER_URL}/communal/aiHelper?${queryParams(
        search
      )}`
    )}&comeFrom=aiHelper`
  }, 2000)
}

const goLoginForAiScript = () => {
  // 跳转到 SaaS移动端 登录页
  setTimeout(() => {
    window.location.href = `${
      process.env.REACT_APP_USER_URL
    }/saasMobile/login?redirectUrl=${encodeURIComponent(
      `${process.env.REACT_APP_USER_URL}/pc-h5-demo/smart-script&fromAi=1`
    )}&comeFrom=aiHelper`
  }, 2000)
}

const goLoginForAiMixCut = () => {
  const reLaunch = window?.wx?.miniProgram?.reLaunch
  // const wxapp = !!getQueryString('wxapp')
  // if (reLaunch && wxapp) {
  if (reLaunch) {
    const urlParams = getUrlParams()
    delete urlParams.personalToken
    delete urlParams.sid
    delete urlParams.third_auto_login_token
    const url = encodeURIComponent(
      `${window.location.origin}/communal/aiMixCut/generateResult?${queryParams(
        urlParams
      )}`
    )
    setTimeout(() => {
      reLaunch({
        url: `/pages/my/my?isShare=1&url=${url}`
      })
    }, 2000)
    return
  }
}

const goLogin = () => {
  if (window.location.pathname.includes('/aiHelper')) {
    // AI助手
    goLoginForAiHelper()
    return
  }
  if (window.location.pathname.includes('/aiScript')) {
    // AI脚本
    goLoginForAiScript()
    return
  }
  if (window.location.pathname.includes('/aiMixCut')) {
    // AI一键成片
    goLoginForAiMixCut()
    return
  }
}

const expireCodeList = [1010, 1011, 1012, 1013, 1014]
instance.interceptors.request.use(
  function (config) {
    const token = getToken()
    const accessToken = getQueryString('access-token')
    accessToken && (config.headers.accessToken = accessToken)
    // 一键成片移动端上传接口请求personaltoken报错 后端塞了一个third_auto_login_token
    const arr = [
      'tool/tool/ChunkedUpload',
      'user/user/Login',
      'creative/ka/Upload/checkUpload',
      'creative/pcm/Video/checkVideoTranscodeProgress',
      'creative/pcm/Video/checkVideoFormat'
    ]
    if (isPersonal()) {
      const flag = arr.some(item => {
        return config.url.includes(item)
      })
      // config.url !== '/user/user/Login/sendSmsCode'
      // ,,,
      if (flag) {
        config.headers.token = getQueryString('third_auto_login_token')
      } else {
        config.headers.token = getPersonalToken()
      }
    } else {
      token && (config.headers.token = token)
    }

    if (config.unHeadersToken) {
      delete config.headers.token
    }

    // if (config.url.includes('user/user/Login/thirdAutoLoginForWechat')) {
    //   // TODO: 这样的判断不好
    //   // 这个拿kz_token的接口
    //   // config.withCredentials = false // 不需要带document.cookie
    //   delete config.headers.token // 不需要发送token
    // }

    if (
      config.url &&
      config.url.substring(0, 4) !== 'http' &&
      config.url.indexOf('/cgi/') !== -1
    ) {
      config.url = process.env.REACT_APP_BASE_API_URL + config.url
    } else if (
      config.url.substring(0, 2) === '//' ||
      config.url.substring(0, 4) === 'http'
    ) {
      config.url = `${config.url}`
    } else {
      config.url = process.env.REACT_APP_BASE_URL + config.url
    }

    // 适配矩阵宝数据面板（抖音/快手）
    if (['dev', 'local'].includes(process.env.REACT_APP_KZ_ENV)) {
      config.headers.sid =
        getQueryString('sid') || getCookieItem('dev_sid') || ''
    } else {
      config.headers.sid = getQueryString('sid') || getCookieItem('sid') || ''
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    // showToast(i18n.t('网络繁忙，请稍后再试'), { duration: 10 * 1000 })
    if (!response.data) {
      // console.error('网络繁忙，请稍后再试')
      showToast(i18n.t('网络繁忙，请稍后再试'))
      return Promise.reject(response)
    } else if (response.data.code === 300013) {
      console.log('您的账号已在其他设备登陆，需要重新登录，请注意账号安全')
      showToast(
        i18n.t('您的账号已在其他设备登陆，需要重新登录，请注意账号安全')
      )
      return {}
    } else if (+response.data.code === 3004) {
      showToast(response.data.message || response.data.error_message)
      return Promise.reject(response.data)
    } else if (expireCodeList.includes(response.data.code)) {
      console.error(
        response.data.message || response.data.error_message || '暂无权限'
      )
      showToast(
        response.data.message ||
          response.data.error_message ||
          i18n.t('暂无权限')
      )
      // 没有权限 跳转登录
      goLogin()
      return Promise.reject(response.data)
    } else if (response.data.code !== 0 && response.data.code !== 200) {
      console.error(response.data.message || response.data.error_message)
      showToast(response.data.message || response.data.error_message)
      return Promise.reject(response)
    } else {
      if (isDev) {
        groupStart(
          `${response.config.method.toUpperCase()} ${response.config.url}`
        )
      }
      return response.data.data || response.data
    }
  },
  error => {
    const isShowErrMsg =
      typeof error.config.isShowErrMsg !== 'undefined'
        ? error.config.isShowErrMsg
        : true
    console.error('网络繁忙，请稍后再试')
    isShowErrMsg && showToast(i18n.t('网络繁忙，请稍后再试'))
    return Promise.reject(error)
  }
)

export default instance

const rainbow = [
  'color: #e74c3c',
  'color: #e67e22',
  'color: #f1c40f',
  'color: #2ecc71',
  'color: #1abc9c',
  'color: #3498db',
  'color: #9b59b6',
  'color: #333'
]
const groupStart = val => {
  let cord = []
  while (cord.length < 7) {
    let n = Math.floor(Math.random() * 7)
    if (!cord.includes(rainbow[n])) {
      cord.push(rainbow[n])
    }
  }
}
